import { render, staticRenderFns } from "./NavigationMenu.vue?vue&type=template&id=801f2cc6&scoped=true"
import script from "./NavigationMenu.vue?vue&type=script&lang=ts"
export * from "./NavigationMenu.vue?vue&type=script&lang=ts"
import style0 from "./NavigationMenu.vue?vue&type=style&index=0&id=801f2cc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801f2cc6",
  null
  
)

export default component.exports